import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import logo from '../assests/img/logo2.png';
import shortlogo from '../assests/img/ad-circle.png';
import axios from 'axios';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from 'react-helmet-async';

const Login = () => {

    const navigate = useNavigate();
    const location = useLocation();

    // const dispatch = useDispatch();
    // const auth = useSelector(state => state.auth);
    const formik = useFormik({
        // Initial values
        initialValues: {
            email: '',
            password: ''
        },

        // Validation Schema
        validationSchema: Yup.object({
            email: Yup.string().required().email(),
            password: Yup.string().required().min(4),
        }),

        // On Submit
        onSubmit: (data) => {
            const { email, password } = data;
            // Use the customer_details API for login (GET request)
            fetch(`https://aadikaash.com/backend/wp-json/aadikaash-api/v1/customer_details?user_id=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`)
                .then(res => res.json())
                .then(apiData => {
                    if (apiData && apiData.status && apiData.data && apiData.data.customer_details) {
                        // Store credentials as JSON string in localStorage
                        localStorage.setItem('user', JSON.stringify({ user_id: email, password }));
                        alert('Login successful!');
                        const redirectTo = location.state?.from || '/dashboard';
                        navigate(redirectTo);
                    } else {
                        alert('Login details wrong!');
                    }
                })
                .catch((err) => {
                    console.log('error:', err.message);
                    alert('Login details wrong!');
                });
        }
    });

    return (
        <>
         <Helmet>
                                  <title>Exhibitor & Visitor Login – ISJS 2025 Jewellery Show Portal</title>
                                  <meta
                                    name="description"
                                    content="Login to your ISJS 2025 account to manage exhibitor bookings, visitor registration, sponsorship details, and event updates."
                                  />
                                  <meta
                        name="keywords"
                        content="ISJS login, jewellery show exhibitor login, visitor registration portal, gemstone trade show India login, exhibition account access"
                      />
                                </Helmet>
            
        <Header/>
            <div className='login-container'>
                <section className="h-screen">
                    <div className="container">
                  

                        <div className="col-md-4 login-form-box">
                        {/* <Link to='/home' className='back-to-home'> Back to home</Link>
                            <div className='col-md-2 main-logo-box'>
                                <Link to='/home' className=''>
                                    <img className='main-logo' src={logo} />
                                    <img className='c-logo' src={shortlogo} />
                                </Link>
                            </div> */}

                            
                            <div class="sec-title"><h2>Exhibitor Login</h2><div class="separator"></div></div>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="mb-3">
                                    <input
                                        type="email"
                                        className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        placeholder="Email address"
                                        name="email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                    />
                                </div>

                                <div className="mb-3">
                                    <input
                                        type="password"
                                        className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        placeholder="Password"
                                        name="password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    data-mdb-ripple="true"
                                    data-mdb-ripple-color="light"
                                // disabled={auth.isLoading}
                                >
                                    Login
                                </button>
                            </form>
                        </div>

                    </div>
                </section>
            </div>
        <Footer/>
        </>
    )
}

export default Login;